export const serviceName = {
  LANDING_MS: 'LANDING',
  USER_ROLES_MS: 'USER-ROLES',
  INTEGRATION_MS: 'INTEGRATION',
  PROJECT_MS: 'PROJECT-MANAGEMENT',
};
